/**
 * Condition-free, prompt-free AI verification metadata leaf (RET1-2556): only
 * client-relevant category metadata. Server rebuilds prompts from ai-verification-prompts.
 */
export const AI_VERIFICATION_REGISTRY = {
  damaged_item_claim: {
    categories: ["item", "packaging"] as const,
    /** At least one image is required for each category before submitting. */
    requiredCategories: ["item", "packaging"] as const,
  },
} as const;

export type AiVerificationType = keyof typeof AI_VERIFICATION_REGISTRY;

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
export const AI_VERIFICATION_TYPES = Object.keys(
  AI_VERIFICATION_REGISTRY,
) as AiVerificationType[];

export interface AiVerificationState {
  verificationType: AiVerificationType;
  requiredCategories: readonly string[];
  imageCategories: Map<string, string>;
  classifyImage: (
    url: URL,
  ) => Promise<{ category: string | null; reason: string }>;
  classificationErrors: Map<string, string>;
  classifying: boolean;
}
